import React, { useEffect, useState } from "react";
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import { useMoralis } from 'react-moralis';
import MarketPlaceList from '../components/MarketPlaceList';

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`;

const Search = ({ searchValue }) => {

  const { Moralis, isInitialized } = useMoralis()
  const [onSaleItems, setOnSaleItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized) {
      try {
        setIsLoading(true)
        const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
        const query = new Moralis.Query(CreatedMarketplaceItems)
        query.fullText('nftName', searchValue)
        query.fullText('nftDescription', searchValue)
        query.equalTo('sold', false)
        query.equalTo('status', 'active')
        query.notEqualTo('userSellingPause', true)
        const result = await query.find()
        setOnSaleItems(result)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.error('MORALIS ERROR : error while fetching marketplace data', error)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  return (
    <div>
      <GlobalStyles />
      <section className='jumbotron breadcumb no-bg'>
        <div className='mainbreadcumb'>
          <div className='container'>
            <div className='row m-10-hor'>
              <div className='col-12'>
                <h1 className='text-center'>Search Results</h1>
              </div>
            </div>
            <div className='d-flex row mt-2'>
              <div className='col-6 justify-content-end align-items-end'>
                {/* <Link to={`/`}> */}
                <h5 className='text-end'>Home</h5>
                {/* </Link> */}
              </div>
              /
              <div className='col-5 justify-content-start align-items-start'>
                <h5 className='text-start'>Search</h5>
              </div>

              {
                isLoading ?
                  (
                    <section className='container'>
                      <div className='row'>
                        <div className='col-sm-12 col-md-12 col-lg-12'>
                          <div className='loading-container'>
                            <div className="spinner-grow" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  ) : (
                    <div className="search-result-container">
                      <MarketPlaceList data={onSaleItems} />
                    </div>
                  )
              }
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
export default Search;